import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';
import { onClickOutside } from '@vueuse/core';
import { getAssetUrl } from '~/composables/useMediaAsset';


export default /*#__PURE__*/_defineComponent({
  __name: 'UiPopup',
  props: {
  value: {
    type: Boolean,
    default: false,
  },
  image: {
    type: String,
    default: undefined,
  },
},
  emits: ['input'],
  setup(__props, { emit }) {

const props = __props;





const popup = ref(null);
const localValue = computed({
  get() {
    return props.value;
  },
  set(newValue) {
    emit('input', newValue);
  },
});

const closePopup = () => (localValue.value = false);

onClickOutside(popup as any, () => closePopup());

return { __sfc: true,props, emit, popup, localValue, closePopup, getAssetUrl }
}

})